import CircuitTable from './CircuitTable';
export default CircuitTable;
